import { render, staticRenderFns } from "./jbdatagrid.vue?vue&type=template&id=54ff390f&scoped=true"
import script from "./jbdatagrid.vue?vue&type=script&lang=js"
export * from "./jbdatagrid.vue?vue&type=script&lang=js"
import style0 from "./jbdatagrid.vue?vue&type=style&index=0&id=54ff390f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ff390f",
  null
  
)

export default component.exports